import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { TiersService } from '../services/tiers.service';
import { Tier } from '../../models/tier';
import { TierRule } from '../../models/tier-rule';
import { ConfirmationService } from 'primeng/components/common/api';
import { MessageService } from 'primeng/components/common/messageservice';
import { Response } from '@angular/http';
import { environment } from '../../../environments/environment';
import { BreadcrumbService } from '../../breadcrumb/breadcrumb.service';

@Component({
	selector: 'app-tier-detail',
	templateUrl: './tier-detail.component.html',
	styleUrls: ['./tier-detail.component.css']
})
export class TierDetailComponent implements OnInit
{
	public tier: Tier;
	public isNew: boolean;

	constructor(private route: ActivatedRoute,
				private router: Router,
				private tiersService: TiersService,
				private confirmationService: ConfirmationService,
				private breadcrumbService: BreadcrumbService,
				private messageService: MessageService)
	{
	}

	ngOnInit()
	{
		if (this.route.snapshot.data['tier'] instanceof Object && !(this.route.snapshot.data['tier'] instanceof Response))
		{
			// Tier was received.
			this.tier = this.route.snapshot.data['tier'];
			this.breadcrumbService.addBreadcrumbTranslation(this.route.snapshot.data['breadcrumb'], this.tier.name);
			this.isNew = false;
		}
		else
		{
			// We are creating a new Tier, or something went wrong.
			this.tier = new Tier();
			this.isNew = true;

			if (this.route.snapshot.data['tier'] instanceof Response)
			{
				// We got a unhandled exception, let's show a message.
				this.messageService.add({
					severity: 'error',
					summary: 'Fout',
					detail: 'Er is een fout opgetreden tijdens het ophalen van de staffel.'
				});
			}
		}
	}

	public goBack()
	{
		this.router.navigate(['/staffels']);
	}

	public removeRule(rule)
	{
		this.tier.tierRules.splice(this.tier.tierRules.indexOf(rule), 1);
	}

	public addRule()
	{
		this.tier.tierRules.push(new TierRule());
	}

	public saveTier()
	{
		let promise: Promise<Tier>;
		if (this.isNew)
		{
			promise = this.tiersService.storeTier(this.tier);
		}
		else
		{
			promise = this.tiersService.updateTier(this.tier);
		}

		promise.then((data) =>
		{
			if (data instanceof Response)
			{
				if (data.status === 422)
				{
					const shownMessages: Array<string> = [];
					const message: Object = data.json().message;

					Object.keys(message).forEach((fieldName) =>
					{
						message[fieldName].forEach((message) =>
						{
							if (shownMessages.indexOf(message) === -1)
							{
								shownMessages.push(message);

								this.messageService.add({
									severity: 'warning',
									summary: 'Validatiefout',
									detail: environment.validation.tier[message]
								});
							}
						});
					});
				}
				else
				{
					this.messageService.add({
						severity: 'error',
						summary: 'Staffel niet opgeslagen',
						detail: 'Er is een fout opgetreden tijdens het opslaan van de staffel.'
					});
				}
			}
			else
			{
				this.messageService.add({
					severity: 'success',
					summary: 'Staffel opgeslagen',
					detail: 'De staffel is opgeslagen.'
				});

				this.router.navigate(['/staffels']);
			}
		});
	}

	public removeTier()
	{
		this.confirmationService.confirm({
			message: 'Weet u zeker dat u deze staffel wilt verwijderen?',
			header: 'Staffel verwijderen?',
			icon: 'fa fa-trash',
			accept: () =>
			{
				this.tiersService.removeTier(this.tier.id)
					.then((data) =>
					{
						this.messageService.add({
							severity: 'success',
							summary: 'Staffel verwijderd',
							detail: 'De staffel is verwijderd.'
						});

						this.router.navigate(['/staffels']);
					})
					.catch((data) =>
					{
						this.messageService.add({
							severity: 'error',
							summary: 'Staffel niet verwijderd',
							detail: 'De staffel kon niet worden verwijderd.'
						});
					});
			}
		});
	}
}



// WEBPACK FOOTER //
// ./src/app/tiers/tier-detail/tier-detail.component.ts